<template>
    <div class="bg">
        <div class="wrap">
            <div class="item" @click="toCase(1)">
                <span>{{title1}}</span>
            </div>
            <div class="item" @click="toCase(2)">
                <span>{{title2}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: '',
        data() {
            return {
                title1:"常规组",
                title2: "强化组",
                hos:"",
                dept:"",
                name:"s",
                pause:false
            }
        },
        methods: {
            toCase(scheme){
                if(this.pause){
                    this.$toast("项目暂停征集，请稍后")
                    return
                }

                this.$router.push({path:"/case",query:{scheme:scheme}})
            }
        },
        mounted(){
            if(this.openId!=''&&this.openId!=null){// 用openid登录
                this.docLoginByOpenId(this.openId)
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


    .bg{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
    }

    .wrap {
        background: #FFF;
        width: 100%;
        max-width: 400px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        justify-content: space-around;
        .item{
            width: 100px;
            height: 100px;
            background: #0082c5;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            span{
                color: #FFF;
                font-size: 20px;
            }
        }
    }

</style>
